<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import CookieReport from "../components/CookieReport.svelte";
	import { getTranslate } from "../utils/getTranslate.js";
	import type { CookiesProps } from "./CookiesProps.js";
	import translations from "./Cookies.translations.json";
	import gdprTranslations from "./Gdpr.translations.json";
	import { getGlobalSettings } from "../getGlobalSettings.js";
	import { getTenant } from "../getTenant.js";
	import { gdprPathMap } from "../../../core/schema/paths/gdprPathMap.js";
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	type $$Props = CookiesProps;

	const translate = getTranslate(translations);
	const gdprTranslate = getTranslate(gdprTranslations);

	const { WEB_URL } = getGlobalSettings();

	const tenant = getTenant();
</script>

<Layout>
	<section class="grid-container flex flex-col px-8 pb-8 sm:items-center lg:px-0">
		<div class="lg:w-[50rem]">
			<h1 class="m-0 mb-4 p-0 font-normal lg:mb-7 lg:leading-[3.25rem]">
				{translate("headline")}
			</h1>
		</div>

		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="text-2md mb-0 text-start font-medium uppercase lg:mt-4 lg:leading-7">
				{translate("whatAreCookiesTitle")}
			</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("whatAreCookies1")}</p>
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">
				{translate("whatAreCookies2")}
				<a href={WEB_URL}>{WEB_URL.slice("https://".length)}</a>
				{translate("whatAreCookies3")}
			</p>
		</div>

		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="text-2md mb-0 text-start font-medium uppercase lg:mt-4 lg:leading-7">
				{translate("typesTitle")}
			</h2>
		</div>
		<div class="w-full lg:w-[50rem]">
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("types")}</p>
			<CookieReport />
		</div>

		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="text-2md mb-0 text-start font-medium uppercase lg:mt-4 lg:leading-7">
				{translate("legalBasisTitle")}
			</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("legalBasis1")}</p>
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("legalBasis2")}</p>
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("legalBasis3")}</p>
		</div>

		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="text-2md mb-0 text-start font-medium uppercase lg:mt-4 lg:leading-7">
				{translate("thirdPartyTitle")}
			</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("thirdParty1")}</p>
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">
				{translate("thirdParty2")}
				<a href="https://policies.google.com/privacy?hl={tenant.locale}" target="_blank">policies.google.com/privacy</a
				>.
			</p>
		</div>

		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="text-2md mb-0 text-start font-medium uppercase lg:mt-4 lg:leading-7">
				{translate("manageTitle")}
			</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("manage1")}</p>
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("manage2")}</p>
		</div>

		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="text-2md mb-0 text-start font-medium uppercase lg:mt-4 lg:leading-7">
				{translate("moreTitle")}
			</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">
				{translate("more1")}
				<a href="/{gdprPathMap[tenant.locale]}">{gdprTranslate("headline")}</a>.
			</p>
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">
				{translate("more2")} <a href="mailto:{translate('email')}">{translate("email")}</a>.
			</p>
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("more3")}</p>
		</div>
	</section>
</Layout>
